module.exports = __webpack_public_path__ + "static/media/4ODA16.8f6d48b2.jpg";